<template>
  <div class="create-order">
    <div class="headLine">
      <img src="./leftAngle.png" alt="返回首页" @click="backIndex" />
      化验设备维修
    </div>
    <div class="form-wrapper">
      <el-form
        label-width="90px"
        label-position="right"
        :rules="rules"
        ref="form"
        :model="formLabelAlign"
      >
        <el-form-item label="设备名称:" prop="name">
          <el-input v-model="formLabelAlign.name" placeholder="请输入设备名" disabled />
        </el-form-item>
<!--        <el-form-item label="维修时间:" prop="time">-->
<!--          <el-date-picker-->
<!--            v-model="formLabelAlign.time"-->
<!--            type="date"-->
<!--            placeholder="维修时间"-->
<!--            format="yyyy-MM-dd"-->
<!--            value-format="yyyy-MM-dd"-->
<!--          />-->
<!--        </el-form-item>-->
        <el-form-item label="备注:" prop="remark" style="margin-top: 20px;">
          <el-input v-model="formLabelAlign.remark"
                    type="textarea"
                    rows="6"
                    maxlength="500"
                    placeholder="备注，500字以内" />
        </el-form-item>

        <el-form-item label="附件:"
                      style="margin-top: 2rem;">
          <div class="upload">
            <UploadImage ref="uploadImage"
                         @changeIsPicSuccess="changeIsPicSuccess"
                         @getFileIds="getFileIds"></UploadImage>
          </div>
        </el-form-item>
        <div class="form-submit">
          <el-button class="btn"
                     :disabled="btnDisabled"
                     :loading="submitTag !== 'normal'"
                     @click.prevent="createOrder">
            <span v-if="submitTag === 'normal'">创建工单</span>
            <span v-else-if="submitTag === 'uploadImg'">图片上传中</span>
            <span v-else>创建中</span>
          </el-button>
          <div class="tips">注：工单将推送给化验部门的设备负责人</div>
        </div>
      </el-form>
    </div>
  </div>
</template>

<script>
import { debounce } from '@/utils/common'
import UploadImage from '@/components/UploadImage'
export default {
  data () {
    return {
      isFixedAssets: false, // 是否是固定资产，默认为是
      id: 0,
      code: null,
      localType: 1,
      pageType: 1,
      formLabelAlign: {
        useDeptId: 0, // 部门id
        assetType: 0, // 类型
        location: null, // 位置
        orderType: 0, // 0维修 1保养--化验要剔除保养
        name: '', // 设备名
        time: "", // 维修时间
        deviceId: '', // 设备id
        remark: "", // 备注
      },
      assetsType: '', // 资产类型
      fileList: [], // 上传的文件列表
      file: null,
      fileIds: [], // 文件id
      rules: {
        name: [
          { required: true, message: '请输入设备名', trigger: 'blur' }
        ],
        location: [
          { required: true, message: '请输入设备位置', trigger: 'blur' }
        ],
        departmentId: [
          { required: true, message: '请选择设备所属部门', trigger: 'blur' }
        ]
      },
      options: [],
      submitTag: 'normal',
      process: 0, // 进度
      btnDisabled: false,
      getDeviceKeyword: null,
      permission: false
    }
  },
  components: {
    UploadImage
  },
  created () {
    this.$nextTick(() => {
      this.getAssetsType()
    })
  },
  methods: {
    // 返回首页
    backIndex() {
      if (this.localType === 1) {
        this.$router.replace({
          name: 'hydeviceinfo',
          query: {
            id: this.id,
            code: this.code,
            keyword: this.getDeviceKeyword,
            permission: this.permission,
          }
        })
      } else if (this.localType === 2) {
        this.$router.replace({
          name: 'deviceCaution'
        })
      } else {
        this.$router.replace({ name: 'hyDevicePage' })
      }

    },
    // 获取设备资产类型
    getAssetsType () {
      this.getDeviceKeyword = this.$route.query.keyword;
      this.permission = this.$route.query.permission;
      // 固定资产还要通过code拿数据
      this.id = this.$route.query.id;
      this.code = this.$route.query.code;
      this.localType = this.$route.query.type;  // type=1,来自设备详情  2来自每周提醒
      this.$http.httpGet(`/app/laDevice/info/${this.id}`, {}).then(res => {
        if (res.code === 0 && res.msg === 'success') {
          let data = res.laDevice
          this.formLabelAlign.name = data.name
          this.formLabelAlign.location = data.location
          this.formLabelAlign.devicePosition = data.devicePosition || '无'
          this.formLabelAlign.id = data.id
          this.formLabelAlign.useDeptId = data.useDeptId
          this.formLabelAlign.assetType = data.assetType
          this.formLabelAlign.orderType = 0
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    createOrder: debounce(function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          if (this.submitTag === 'normal') {
            this.submitTag = 'creating'
            let filePost = [];
            if (this.fileIds.length > 0) {
              this.fileIds.forEach(i => {
                filePost.push({
                  fileInfoId: i
                })
              })
            } else {
              filePost = [];
            }
            this.$http.httpPost('/app/laDeviceRepairOrder/addDeviceOrder', {
              "deviceId": this.id,
              "deviceName": this.formLabelAlign.name,
              "departmentId": this.formLabelAlign.useDeptId,
              "description": this.formLabelAlign.remark,
              "assetType": this.formLabelAlign.assetType,
              "orderType": this.formLabelAlign.orderType,
              "location": this.formLabelAlign.location,
              "fileIds": filePost,

            }).then(res => {
              if (res.code === 0 && res.msg === 'success') {
                this.$message({
                  message: '创建成功',
                  type: 'success'
                });
                this.$refs.uploadImage.clearFile()
                this.formLabelAlign = {
                  "name": '',
                  "time": '',
                  "remark": '',
                }
                this.back()
              } else {
                this.$message({
                  message: `创建失败，错误信息:${res.msg}`,
                  type: 'error'
                });
              }
              this.submitTag = 'normal'
              this.btnDisabled = true
            })
          }
        } else {
          // 校验没通过
          this.$message({
            message: '校验不通过',
            type: 'error'
          });
        }
      })
    }),
    // 回到工单列表页面
    back () {
      setTimeout(() => {
        if (this.localType === 1) {
          this.$router.replace({
            name: 'hydeviceinfo',
            query: {
              id: this.id,
              code: this.code,
              keyword: this.getDeviceKeyword,
              permission: this.permission,
            }
          })
        } else {
          this.$router.replace({ name: 'hyDevicePage' })
        }
      }, 1000);
    },
    changeIsPicSuccess (flag) {
      this.submitTag = flag ? 'normal' : 'uploadImg'
    },
    getFileIds (fileIds) {
      this.fileIds = fileIds
    }
  }
}
</script>

<style lang="scss">
@import '@/assets/style/global.scss';
.create-order {
  width: 100%;
  padding: 50px 0 0;
  background: #fff;
  .headLine {
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    background-color: #fff;
    height: 50px;
    color: #000;
    font-weight: 600;
    text-align: center;
    line-height: 50px;
    font-size: 16px;
    z-index: 99;
    border-bottom: 1px #efefef solid;
    img {
      height: 30px;
      margin: 10px 0;
      padding: 0 10px;
      position: absolute;
      left: 0;
      top: 0;
    }
  }
  .form-wrapper {
    .el-form {
      padding: 15px 15px;
      .el-form-item__label {
        // font-weight: 700;
        font-size: 14px;
        color: #000;
      }
      .el-form-item {
        margin-bottom: 10px;
        .fixed {
          position: relative;
          .fixed-device-name {
            border: none;
            outline: none;
            font-size: 1.6rem;
            background-color: inherit;
            cursor: not-allowed;
          }
          input:disabled {
            color: #333;
            opacity: 0.8;
            -webkit-text-fill-color: #333;
          }
          .fixed-btn {
            position: absolute;
            right: 0;
            top: 0;
            width: 8rem;
            height: 3rem;
            font-size: 1.2rem;
            color: #fff;
            background: #409eff;
          }
        }
      }
      .form-submit {
        text-align: center;
        width: 100%;
        z-index: 99;
        border-top: 1px #efefef solid;
        border-bottom: 1px #efefef solid;
        button {
          width: 80%;
          height: 4rem;
          margin: 10px 0;
          background-color: #67c23a;
          font-size: 1.6rem;
          font-weight: bold;
          &:hover,
          &:active {
            color: #fff;
          }
        }
        .tips {
          font-size: 1.4rem;
          color: #ccc;
          // margin-top: 1rem;
          padding-bottom: 0.5rem;
        }
      }
    }
  }
}
.el-radio.is-disabled {
  border-color: #e4e7ed;
  color: #333;
  opacity: 0.8;
  -webkit-text-fill-color: #333;
  cursor: not-allowed;
}
</style>
